module.exports = __webpack_public_path__ + "static/media/3_7Kang.51959e2e.png";